import { Alert, CheckCircleIcon } from '@razorpay/blade/components';
import { FutureCompensation } from 'api/gql-utils/payDetails/compensationTypes';
import React from 'react';
import { dateFormats, getFormattedDateValue } from 'utils/Dates';
import { paiseAmountToRupee, toIndianCurrencyString } from 'utils/Numbers';

export const RevisedCompensationAlert = ({ futureCompensation }: { futureCompensation: FutureCompensation }) => {
  return futureCompensation.futureCompensationAmount > 0 ? (
    <Alert
      isFullWidth
      color={'information'}
      title={`Revised compensation of ${toIndianCurrencyString(
        paiseAmountToRupee(futureCompensation.futureCompensationAmount),
      )} will be effective from ${getFormattedDateValue({
        date: futureCompensation.futureCompensationDate,
        formatString: dateFormats.dateMonthCommaYear,
      })}`}
      description={''}
      icon={CheckCircleIcon}
    />
  ) : null;
};
